import { MarkedExtension } from 'marked';

export const linkTargetBlankExtension: MarkedExtension = {
  hooks: {
    postprocess(html) {
      return html.replace(
        /<a href=/g,
        '<a target="_blank" rel="noopener noreferrer" href='
      );
    },
  },
};
